
/* See https://www.algolia.com/doc/integration/shopify/advanced-customization/customizing-instant-search/#hogan */
(function(algolia) {
    'use strict';
    var Hogan = algolia.externals.Hogan;
  
    var formatPrice = function formatPrice(value) {
      return algolia.formatMoney(Number(value) * 100);
    };
  
    function formattedPriceWithComparison(price, compare_at_price, price_ratio) {
      var comparing =
        Number(compare_at_price) && Number(compare_at_price) > Number(price);
      var discount_ratio = 1.0 - price_ratio;
      var res = '<b>' + formatPrice(price) + '</b>';
      if (comparing) {
        res += 
          ' <span class="ais-hit--price-striked"><span>' +
          formatPrice(compare_at_price) +
          '</span></span> ';
        res +=
          ' <span class="ais-hit--price-discount" style="font-weight: ' +
          Math.floor(discount_ratio * 10) * 100 +
          ';">-' +
          Math.floor(discount_ratio * 100) +
          '%</span>';
      }
  
      return res;
    }

    function formattedProductPriceWithComparison(price, compare_at_price, price_ratio) {
      var comparing =
        Number(compare_at_price) && Number(compare_at_price) > Number(price);
      var discount_ratio = 1.0 - price_ratio;
      var res = '';
      if (comparing) {
        res = '<span class="ais-hit--price-red">' + formatPrice(price) + '</span>';
        res += 
          ' <span class="ais-hit--price-striked"><span>' +
          formatPrice(compare_at_price) +
          '</span></span> ';
      } else{
        res = '<span>' + formatPrice(price) + '</span>';
      }
  
      return res;
    }
  
    var escapeHtml = function escapeHtml(unsafe) {
      return (unsafe || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    };
  
    algolia.helpers = {
      formatNumber: function formatNumber(text, render) {
        return Number(render(text)).toLocaleString();
      },
      formattedPrice: function formattedPrice(text, render) {
        return formatPrice(render(text));
      },
      formattedPriceWithoutDecimals: function formattedPriceWithoutDecimals(
        text,
        render
      ) {
        return formatPrice(render(text)).replace(/\.\d+$/, '');
      },
      autocompletePrice: function autocompletePrice() { 
        if (this._distinct) {
          var min = this.variants_min_price;
          var max = this.variants_max_price;
          if (min !== max) {
            return '<p>' + formatPrice(min) + ' - ' + formatPrice(max) + '</p>';
          }
        }
        return formattedPriceWithComparison(this.price, null);
      },
      instantsearchPrice: function instantsearchPrice() {
        if (this._distinct) {
          var min = this.variants_min_price;
          var max = this.variants_max_price;
          if (min !== max) {
            return '<b>' + formatPrice(min) + ' - ' + formatPrice(max) + '</b>';
          }
        }
        return formattedPriceWithComparison(
          this.price,
          this.compare_at_price,
          this.price_ratio
        );
      },
      instantProductPrice: function instantProductPrice() {
        if (this._distinct) {
          var min = this.variants_min_price;
          var max = this.variants_max_price;
          if (min !== max) {
            return '<p>' + formatPrice(min) + ' - ' + formatPrice(max) + '</p>';
          }
        } 
        return formattedProductPriceWithComparison(
          this.price,
          this.compare_at_price
        );
      },
      instantsearchLink: function instantsearchLink() {
        var addVariantId = !this._distinct && this.objectID !== this.id;
        return (
          '/products/' +
          this.handle +
          (addVariantId ? '?variant=' + this.objectID : '')
        );
      },
      fullTitle: function fullTitle() {
        var res = this.title;
        if (
          !this._distinct &&
          this.variant_title &&
          this.variant_title !== 'Default Title' &&
          this.variant_title !== 'Default'
        ) {
          res += ' (' + this.variant_title + ')';
        }
  
        return escapeHtml(res);
      },
      fullHTMLTitle: function fullHTMLTitle() {
        var res = this._highlightResult.title.value;
        if (
          !this._distinct &&
          this.variant_title &&
          this.variant_title !== 'Default Title' &&
          this.variant_title !== 'Default'
        ) {
          res += ' <span class="algolia-variant">(' + res + ')</span>';
        }
        return res;
      },
      fullEscapedAttribute(attribute) {
        return new DOMParser().parseFromString(attribute, 'text/html')
          .documentElement.textContent;
      },
      fullEscapedHTMLTitle: function fullEscapedHTMLTitle() {
        var res = algolia.helpers.fullEscapedAttribute(
          this._highlightResult.title.value
        );
        if (
          !this._distinct &&
          this.variant_title &&
          this.variant_title !== 'Default Title' &&
          this.variant_title !== 'Default'
        ) {
          res += ' <span class="algolia-variant">(' + res + ')</span>';
        }
        return res;
      },
      fullEscapedHTMLProductType: function fullEscapedHTMLProductType() {
        return algolia.helpers.fullEscapedAttribute(
          this._highlightResult.product_type.value
        );
      },
      fullEscapedHTMLVendor: function fullEscapedHTMLVendor() {
        return algolia.helpers.fullEscapedAttribute(
          this._highlightResult.vendor.value
        );
      },
      floor: function floor(text, render) {
        return '' + Math.floor(Number(render(text)));
      },
      ceil: function ceil(text, render) {
        return '' + Math.ceil(Number(render(text)));
      },
      sizedImage: function sizedImage(text, render) {
        var image = this._distinct ? this.product_image : this.image;
        if (!image) {
          return 'https://cdn.shopify.com/s/images/admin/no-image-compact.gif';
        }
        var size = render(text).replace(/^\s+|\s+$/g, ''); // Render and trim
        if (size === 'original') {
          return image;
        }
        return image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + size + '.$2');
      },
      inStoreOnly: function inStoreOnly() {
        var inStoreOnly = false;
        this.tags.forEach((item) => {
          if(item == 'in-store-only'){
            inStoreOnly = true;
          }
        });
        if(inStoreOnly){
          return '<span class="in-store-only">In Store Only</span>';
        } else {
          return '';
        }
      },
      inStoreOnlyClass: function inStoreOnlyClass() {
          var inStoreOnly = false;
          this.tags.forEach((item) => {
            if(item == 'in-store-only'){
              inStoreOnly = true;
            }
          });
          if(inStoreOnly){
            return 'hidden';
          } else {
            return '';
          }
      },
      inStoreOnlyFlex: function inStoreOnlyFlex() {
        var inStoreOnly = false;
        this.tags.forEach((item) => {
          if(item == 'in-store-only'){
            inStoreOnly = true;
          }
        });
        if(inStoreOnly){
          return 'in-store-only';
        } else {
          return '';
        }
      },
      isProductBadge: function isProductBadge() { 
        if (this.named_tags.BADGE) { 
          return `<span class="offer-pill">${this.named_tags.BADGE}</span>`;
        }
      },
      isLowSugar: function isLowSugar(){
        let dietaryMeta = this.meta.dietary;
        if(dietaryMeta && dietaryMeta['LowSugar']){
            if(dietaryMeta['LowSugar'] === 'Yes'){
              return '<span style="background-color:#efa434;" title="Low Sugar">LS</span>'; 
            } 
        } 
      },
      isGlutenFree: function isGlutenFree(){
        let dietaryMeta = this.meta.dietary;
        if(dietaryMeta && dietaryMeta['GlutenFree']){
            if(dietaryMeta['GlutenFree'] === 'GF'){
              return '<span style="background-color: #81307a;" title="Gluten Free">GF</span>';
            } else if(dietaryMeta['GlutenFree'] === 'NG') {
              return '<span style="background-color: #81307a;" title="No Gluten">NG</span>';
          }
        } 
      },
      isVegetarian: function isVegetarian(){
        let dietaryMeta = this.meta.dietary;
        if(dietaryMeta && dietaryMeta['Vegetarian']){
            if(dietaryMeta['Vegetarian'] === 'Yes'){
              return '<span style="background-color:#008c3c;" title="Vegetarian">V</span>';
            }
        } 
      },
      isVegan: function isVegan(){
        let dietaryMeta = this.meta.dietary;
        if(dietaryMeta && dietaryMeta['Vegan']){
            if(dietaryMeta['Vegan'] === 'Yes'){
              return '<span style="background-color: #0097da;" title="Vegan">V+</span>';
            }
        } 
      },
      isOrganic: function isOrganic(){
        let dietaryMeta = this.meta.dietary;
        if(dietaryMeta && dietaryMeta['Organic']){
            if(dietaryMeta['Organic'] === 'Yes'){
              return '<span style="background-color: #005f2d;" title="Organic">O</span>';
            }
        } 
      },
      getSize: function getSize(){
        //console.log(this.meta);
        let size = this.meta.general;
        if(size && size['Size']){
            return size['Size'];
        } 
      },
      inventoryAvailable: function inventoryAvailable() {
        let inventoryAvailable = this.inventory_available;
        if(inventoryAvailable){
          return inventoryAvailable;
        }
      },
      inventoryManagement: function inventoryManagement(){
        let inventoryManagement = this.inventory_management;
        if(inventoryManagement){
          return inventoryManagement;
        }
      },
      inventoryPolicy: function inventoryPolicy() {
        let inventoryPolicy = this.inventory_policy;
        if(inventoryPolicy){
          return inventoryPolicy;
        }
      },
      inventoryQuantity: function inventory_quantity() {
        let inventoryQuantity = this.inventory_quantity;
        if(inventoryQuantity){
          return inventoryQuantity;
        } 
      },
      qtyDataLimit: function qtyDataLimit(){
        if(this.inventory_management == 'shopify' && this.inventory_policy == 'deny'){
          return 'data-limit="'+this.inventory_quantity+'"';
        } else if(this.inventory_management == 'shopify' && this.inventory_policy == 'continue'){
          return 'data-limit="999"';
        }
      },
      qtyStockMsg: function qtyStockMsg(){
        if(this.inventory_quantity == 1){
          return 'Only '+this.inventory_quantity+' item in stock';
        }else {
          return 'Only '+this.inventory_quantity+' items in stock';
        } 
      },
      productPromotion: function productPromotion(){
        if(this.named_tags.PROMO_NAME_TAG){
          let promoTag = this.named_tags.PROMO_NAME_TAG;
          let promotionLink;
          if(this.named_tags.PROMO_COLLECTION){ 
            promotionLink = '/collections/'+encodeURIComponent(this.named_tags.PROMO_COLLECTION);  
          }
          if(promotionLink){ 
            return '<a class="product-promotions-display" href="'+promotionLink+'"><div class="offer-pill">OFFER</div><div class="offer-text">'+this.named_tags.PROMO_NAME_TAG+'</div></a>'
          } else{
            let bodyElm = document.querySelector('body');
            let genericPromotionsCollection = bodyElm.getAttribute('data-generic-promotions-collection');
            let genericPromotionsLink = '';
            if(genericPromotionsCollection){ 
              genericPromotionsLink = '/collections/'+genericPromotionsCollection+'/?refinementList%5Bnamed_tags.PROMO_NAME_TAG%5D%5B0%5D='+encodeURIComponent(promoTag);
            } else{
              genericPromotionsLink = '/collections/all/?refinementList%5Bnamed_tags.PROMO_NAME_TAG%5D%5B0%5D='+encodeURIComponent(promoTag);
            }
            return '<a class="product-promotions-display" href="'+genericPromotionsLink+'"><div class="offer-pill">OFFER</div><div class="offer-text">'+this.named_tags.PROMO_NAME_TAG+'</div></a>'
          } 
        } 
      },
    }; 
  
    [
      'pico',
      'icon',
      'thumb',
      'small',
      'compact',
      'medium',
      'large',
      'grande',
      'original',
    ].forEach(function(size) {
      algolia.helpers[size + 'Image'] = (function(_size) {
        return function() {
          var image = this._distinct ? this.product_image : this.image;
  
          if (!image) {
            return 'https://cdn.shopify.com/s/images/admin/no-image-compact.gif';
          }
  
          if (_size === 'original') {
            return image;
          }
  
          return image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + _size + '.$2');
        };
      })(size); // We need to create a new scope so that the internal size has the good value.
    });
  
    /* Create an Hogan lambda, which doesn't respect the mustache doc */
    var helpers = algolia.assign(
      {},
      algolia.helpers,
      algolia.translation_helpers
    );
    var helpersNames = Object.keys(helpers);
    var i = helpersNames.length;
    var helpersArray = new Array(i);
    while (i--) helpersArray[i] = [helpersNames[i], helpers[helpersNames[i]]];
  
    algolia.hoganHelpers = helpersArray.reduce(function(res, options) {
      var name = options[0];
      var helper = options[1];
  
      var newRes = algolia.assign({}, res);
  
      newRes[name] = function() {
        return function(text) {
          var render = function(value) {
            return Hogan.compile(value, algolia.hoganOptions).render(this);
          }.bind(this);
  
          return helper.call(this, text, render);
        }.bind(this);
      };
  
      return newRes;
    }, {});
  })(window.algoliaShopify);
  